import { render, staticRenderFns } from "./PQTOffersView.vue?vue&type=template&id=2dd70a80&"
import script from "./PQTOffersView.vue?vue&type=script&lang=js&"
export * from "./PQTOffersView.vue?vue&type=script&lang=js&"
import style0 from "./PQTOffersView.vue?vue&type=style&index=0&id=2dd70a80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports